import { render, staticRenderFns } from "./EditTerminalToDoor.vue?vue&type=template&id=d473e3d0"
import script from "./EditTerminalToDoor.vue?vue&type=script&lang=js"
export * from "./EditTerminalToDoor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports